export function initializePaymentTypeSelector() {
    let paymentField = $('#payment_method');
    $(paymentField).on('change', function () {
        if ($(this).val() === 'cheque' || $(this).val() === '2') {
            $('#check_number').closest('div').show();
            $('#payable_to').closest('div').show();
        } else {
            $('#check_number').closest('div').hide();
            $('#payable_to').closest('div').hide();
        }
    });
    $(paymentField).trigger('change');
}
